import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function ProductSection() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  const features = [{
    title: 'The "Un-Claim" Checklist',
    desc: 'Do you qualify for a 12-month reset? (And where to get the cash to pay it back).'
  }, {
    title: 'The Survivor Shield',
    desc: "How to ensure your wife isn't penalized for your early claim."
  }, {
    title: 'The "Zero-Cringe" SSA Scripts',
    desc: "Exactly what to say to the agent so they don't give you the runaround."
  }, {
    title: 'The Breakeven Calculator',
    desc: 'Know exactly when your "new" higher check pays off the "old" mistake.'
  }];
  return <motion.section initial="hidden" whileInView="visible" viewport={{
    once: true
  }} variants={fadeIn} className="mt-20 pt-12 border-t border-[#1B2A4A]/10" data-id="element-153">
      <div className="text-center mb-12" data-id="element-154">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-6" data-id="element-155">
          Introducing: The Social Security Claiming Mistake Rescue
        </h2>
        <p className="text-lg md:text-xl text-[#1B2A4A]/80 max-w-2xl mx-auto italic mb-4" data-id="element-156">
          This is not a 300-page textbook. It is a 15-minute &quot;Tactical
          PDF&quot; designed for the retired man who wants to stop the bleeding
          and fix his income now.
        </p>
        <p className="text-sm md:text-base text-[#1B2A4A]/60 max-w-2xl mx-auto" data-id="element-157">
          Developed by retirement income specialists who&apos;ve helped over
          2,000 retirees navigate the Social Security system.
        </p>
      </div>

      <div className="bg-white p-8 md:p-12 rounded-lg shadow-sm border border-[#1B2A4A]/5 mb-12" data-id="element-158">
        <h3 className="text-2xl font-bold text-[#1B2A4A] mb-8 border-b border-[#1B2A4A]/10 pb-4" data-id="element-159">
          What&apos;s Inside:
        </h3>
        <ul className="space-y-6" data-id="element-160">
          {features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-161">
              <div className="flex-shrink-0 mt-1" data-id="element-162">
                <div className="bg-[#D4652A]/10 rounded-full p-1" data-id="element-163">
                  <CheckIcon className="w-5 h-5 text-[#D4652A]" strokeWidth={3} data-id="element-164" />
                </div>
              </div>
              <div className="ml-4" data-id="element-165">
                <span className="font-bold text-[#1B2A4A] text-lg block mb-1" data-id="element-166">
                  {feature.title}
                </span>
                <span className="text-[#1B2A4A]/80 text-lg" data-id="element-167">
                  {feature.desc}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </motion.section>;
}